import * as z from "zod";

// Keys equal the team.settings.* path with dots→slashes.
export const CustomerPortalFlatTeamSettingsSchema = z.object({
  // AI exchange agent
  "exchangeAgent/enabled": z.boolean().nullish(),
  "exchangeAgent/displayExchangeValueAsDiscount": z.boolean().nullish(),
  "exchangeAgent/variantRecommendations/enabled": z.boolean().nullish(),
  "exchangeAgent/productRecommendations/enabled": z.boolean().nullish(),
  "exchangeAgent/productRecommendations/limit": z.number().nullish(),
  "exchangeAgent/productRecommendations/tagExclusionRules": z
    .array(
      z.object({ sourceTag: z.string(), excludedTags: z.array(z.string()) }),
    )
    .nullish(),

  // Exchange settings
  "exchanges/variantPickerColorHexMetafield": z.string().nullish(),
  "exchanges/selection": z.string().nullish(),
  checkoutSelector: z.string().nullish(),
  "exchanges/shopSiteURL": z.string().nullish(),
  exchangeBannerColor: z.string().nullish(),
  exchangeBannerFontColor: z.string().nullish(),
  exchangeBannerFont: z.string().nullish(),
  exchangeBannerText: z.string().nullish(),
  exchangeBannerCustomCss: z.string().nullish(),
  exchangeBannerShowDoneButton: z.boolean().nullish(),
  "shopifyExtension/exchangeBannerPositionBottom": z.boolean().nullish(),
  "shopifyExtension/exchangeBannerInsertBeforeBody": z.boolean().nullish(),
  "exchanges/exchangeOptionsPreviewShowOriginalPrice": z.boolean().nullish(),
  exchangeGroups: z.array(z.unknown()).nullish(),
  "exchanges/allowCustomerDiscountCodes": z.boolean().nullish(),
  "exchanges/differentPricedVariantExchanges": z.boolean().nullish(),
  "exchanges/variantExchangeProductTags": z.array(z.string()).nullish(),
  "exchanges/excludeDifferentPriceVariants": z.boolean().nullish(),
  "exchanges/recreateExpiredDiscounts": z.boolean().nullish(),
  "exchanges/recreateAutomaticDiscountsAsCodes": z.boolean().nullish(),
  "exchanges/shopSiteUseCartDiscounts": z.boolean().nullish(),
  "exchanges/applyOriginalOrderDiscounts": z.array(z.string()).nullish(),
  "exchanges/applyAutomaticDiscounts": z.array(z.string()).nullish(),
  "exchanges/reapplyCompareAtDiscount": z.boolean().nullish(),
  "exchanges/advancedExchanges": z.string().nullish(),
  "exchanges/excludeProductTags": z.array(z.string()).nullish(),
  "exchanges/excludeProductSkus": z.array(z.string()).nullish(),
  "inventory/minimum_stock": z.number().nullish(),
  "exchanges/allowInstant": z.boolean().nullish(),
  "exchanges/instantHoldAmount": z.string().nullish(),
  "exchanges/instantExchangeOnly": z.boolean().nullish(),
  "exchanges/instantExpirationDays": z.number().nullish(),
  "exchanges/hideOutOfStockVariants": z.boolean().nullish(),
  "exchanges/hideUnpublishedVariants": z.boolean().nullish(),

  // Predefined categories
  "returns/aiReturnReasons/usePredefinedCategories": z.boolean().nullish(),
  "returns/aiReturnReasons/predefinedCategories": z
    .array(z.object({ code: z.string(), name: z.string() }))
    .nullish(),

  // Discount distribution
  discountDistributionMethod: z.string().nullish(),

  // Localization
  "localization/enabled": z.boolean().nullish(),

  // Bundles
  "returns/bundleReturnMode": z.string().nullish(),
  "returns/useShopifyNativeBundles": z.boolean().nullish(),
  "returns/bundleRestockingType": z.string().nullish(),
  "returns/returnTogether": z
    .array(
      z.object({ selector: z.string().nullish(), value: z.string().nullish() }),
    )
    .nullish(),
});
